var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "not-found-container" }, [
    _c("div", { staticClass: "loading-container" }, [
      _c("img", {
        staticClass: "pic-404__parent",
        attrs: { src: require("../assets/img/not-found.svg"), alt: "404" }
      }),
      _c("h1", [_vm._v(_vm._s(_vm.statusText))]),
      _c(
        "div",
        { staticClass: "btn-row" },
        [
          _vm.showLogin
            ? _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.goLogin }
                },
                [_vm._v("重新登录")]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }